<div class="drawer-content">
  @if (isVersionHistoryMode) {
  <!-- Your version history UI -->
  <div class="version-history-container">
    <header class="version-header">
      <span>
        <mat-icon svgIcon="quote-version-history"></mat-icon>
        <p class="version-history-text">Version history</p>
      </span>
      @if(hasOnlyDraftVersion()){
      <button (click)="closeVersionHistory()">
        <mat-icon svgIcon="icon-close" class="close"></mat-icon>
      </button>
      }
    </header>
    <div class="timeline">
      <div class="timeline-item" *ngFor="let item of versionHistory(); let last = last" [class.last]="last"
        [class.selected]="isTimelineItemSelected(item)" (click)="selectTimelineItem(item)">

        <!-- Left Rail -->
        <div class="timeline-rail">
          <span class="dot" [class.selected]="isTimelineItemSelected(item)"></span>
          <span class="line"></span>
        </div>

        <!-- Right Content -->
        <div class="timeline-content">

          <div class="timeline-header">
            <span class="version" [class.selected]="isTimelineItemSelected(item)">
              {{ item.version }}
            </span>

            <img src="assets/images/generic-agent.svg" class="avatar" />
          </div>
          <div class="history-footer">
            <span class="date">
              {{ formatVersionDateTime(item.modifiedOnDate ? item.modifiedOnDate : item.createdOnDate) }}
            </span>
            <div class="dot"></div>
            <span class="quotes">
              Quotes ({{ item.quotes }})
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  } @else {
  <div class="drawer-sections">
    @for (section of accordionSections; track $index; let i = $index) {
    <div class="accordion-section"
      [ngClass]="{'open': accordionOpen[i], 'comparison-mode-full-height': isComparison && i === 0}">

      <!-- Header: click only here -->
      <div class="accordion-header-row" [ngClass]="{ 'no-click': isComparison && i === 0 }"
        (click)="!isComparison || i !== 0 ? openAccordion(i) : null">
        <mat-icon class="accordion-icon"
          [svgIcon]="isComparison && i === 0 ? 'icon-comparison-profile' : section.icon"></mat-icon>
        <span *ngIf="!isComparison" class="accordion-title">{{ section.title }}</span>
        <span *ngIf="isComparison" class="accordion-title">Profile Summary</span>
        <mat-icon *ngIf="section.helpIcon" class="accordion-help" svgIcon="icon-help-circle"></mat-icon>

        <app-tooltip [text]="getAccordionTooltip(section)" [position]="'above'">
          <mat-icon *ngIf="section.refreshIcon" class="accordion-refresh" [svgIcon]="section.refreshIcon"
            (click)="onAccordionIconsClick($event, section)">
          </mat-icon>
        </app-tooltip>
      </div>

      <!-- Content: dont close accordion -->
      @if (accordionOpen[i]) {
      <div class="accordion-content" (click)="$event.stopPropagation()">
        <ng-container *ngTemplateOutlet="section.contentTpl"></ng-container>
      </div>
      }

    </div>
    }
  </div>
  }
</div>

<!-- Accordion Content Templates -->

<ng-template #leadSummaryContent>
  <div class="lead-summary-container">
    <div class="lead-summary-scroll-content">

      @for (quote of quoteData(); track quote.id) {

      <!-- ================= LEAD HEADER ================= -->
      <div class="leads-summary">
        <div class="initials-circle">
          {{ getInitials(quote.name) }}
        </div>

        <div class="lead-info">
          <app-tooltip [text]="quote.name" [position]="'above'" class="customer-name-tooltip"
            [disabled]="!isTextOverflowing(customerName)">
            <h3 #customerName class="customer-name">{{ quote.name }}</h3>
          </app-tooltip>
        </div>
      </div>

      <div class="leadid-container">
        @if (isComparison) {
        <span class="ref-id">Ref. ID:</span>
        }
        <span class="detail-value"> {{ quote.refId }}</span>
        @if (quote.isPep) {
        <span class="leadid-dot">•</span>
        <app-tooltip [text]="'Politically Exposed Person (PEP)'" position="above">
          <span class="pep-flag-chip">
            <span class="pep-icon-wrap">
              <mat-icon [svgIcon]="'pep-badge'"></mat-icon>
            </span>
            <span>PEP</span>
          </span>
        </app-tooltip>
        }
      </div>


      <!-- ================= MEMBERS TO COVER ================= -->
      <div class="info-card">
        <div class="info-item">
          <mat-icon class="field-icon" svgIcon="shield-plus-navy"></mat-icon>
          <div class="info-content">
            <span class="info-label">Members to Cover</span>
            <span class="info-value">{{ quote.coverMembers }}</span>
          </div>
        </div>
      </div>

      <!-- ================= PREFERENCES ================= -->
      <div class="section">
        <h3 class="section-title">Preferences</h3>

        <div class="info-card">

          <div class="info-item">
            <mat-icon class="field-icon" svgIcon="expand-arrows"></mat-icon>
            <div class="info-content">
              <span class="info-label">Network Access</span>
              <span class="info-value">{{ quote.networkAccess }}</span>
            </div>
          </div>

          <div class="info-item">
            <mat-icon class="field-icon" svgIcon="hospital-plus"></mat-icon>
            <div class="info-content">
              <span class="info-label">Hospital List</span>
              <span class="info-value">{{ quote.hospitalList }}</span>
            </div>
          </div>

          <div class="info-item">
            <mat-icon class="field-icon" svgIcon="icon-heart-check"></mat-icon>
            <div class="info-content">
              <span class="info-label">Copay Option</span>
              <span class="info-value">{{ quote.copay }}</span>
            </div>
          </div>

          <div class="info-item">
            <mat-icon class="field-icon" svgIcon="icon-hospital"></mat-icon>
            <div class="info-content">
              <span class="info-label">Previous Insurer</span>
              <span class="info-value">{{ quote.prevInsurer }}</span>
            </div>
          </div>

          <div class="info-item">
            <mat-icon class="field-icon" svgIcon="icon-previous-premium"></mat-icon>
            <div class="info-content">
              <span class="info-label">Previous Insurer's Premium</span>
              <span class="info-value">{{ quote.previousPremium }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- ================= APPLICANT INFO ================= -->
      <div class="section">
        <h3 class="section-title">Applicant Info</h3>

        <div class="info-card-grid">

          <!-- ===== PRIMARY APPLICANT (SINGLE) ===== -->
          <div class="info-card">
            <div class="applicant-section">
              <span class="applicant-label">Primary Applicant</span>

              <div class="applicant-details">
                <mat-icon class="field-icon" svgIcon="icon-user-outline"></mat-icon>

                <div class="applicant-info">
                  <div class="applicant-row">
                    <span class="applicant-field">Age:</span>
                    <span class="applicant-value">
                      {{ quote.primaryAge }}
                    </span>
                  </div>

                  <div class="applicant-row">
                    <span class="applicant-field">Gender:</span>
                    <span class="applicant-value">
                      {{ quote.primaryGender }}
                    </span>
                  </div>

                  <div class="applicant-row">
                    <span class="applicant-field">Marital Status:</span>
                    <span class="applicant-value">
                      {{ quote.primaryMaritalStatus }}
                    </span>
                  </div>

                  <div class="applicant-row">
                    <span class="applicant-field">Emirate:</span>
                    <span class="applicant-value">
                      {{ quote.primaryEmirate }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ===== DEPENDENTS (MULTIPLE) ===== -->
          @for (dep of quote.dependents; track $index) {

          <div class="info-card">
            <div class="applicant-section">
              <span class="applicant-label">
                Dependent (Family Member {{ $index + 1 }})
              </span>

              <div class="applicant-details">
                <mat-icon class="field-icon" svgIcon="icon-user-group"></mat-icon>

                <div class="applicant-info">
                  <div class="applicant-row">
                    <span class="applicant-field">Age:</span>
                    <span class="applicant-value">{{ dep.age }}</span>
                  </div>

                  <div class="applicant-row">
                    <span class="applicant-field">Gender:</span>
                    <span class="applicant-value">{{ dep.gender }}</span>
                  </div>

                  <div class="applicant-row">
                    <span class="applicant-field">Marital Status:</span>
                    <span class="applicant-value">{{ dep.maritalStatus }}</span>
                  </div>

                  <div class="applicant-row">
                    <span class="applicant-field">Emirate:</span>
                    <span class="applicant-value">{{ dep.emirate }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          }

        </div>
      </div>

      }

    </div>
  </div>
</ng-template>

<ng-template #feedbackContent>
  <div class="feedback-container">
    <div class="feedback-scroll-content">

      @for (feedback of feedbackData(); track feedback.id) {

      <div class="feedback-item">
        <div class="feedback-header">
          <span class="feedback-date">{{ feedback.date | date:'MMM d, y, h:mm a' }}</span>
          <div class="initials-circle">
            {{ getInitials(leadData?.clientName) }}
          </div>
        </div>

        <div class="feedback-message">
          {{ feedback.message }}
        </div>
      </div>

      <!-- Date Separator -->
      @if ($index < feedbackData().length - 1 && getDateGroup(feedback.date) !==getDateGroup(feedbackData()[$index +
        1].date)) { <div class="date-separator">
        <span class="separator-line"></span>
        <span class="separator-text">{{ getDateGroup(feedbackData()[$index + 1].date) }}</span>
        <span class="separator-line"></span>
    </div>
    }

    }

    <!-- Empty State (if no feedback) -->
    @if (feedbackData().length === 0) {
    <div class="feedback-empty-state">
      <mat-icon class="empty-icon" svgIcon="feedback-outline"></mat-icon>
      <p class="empty-text">No feedback yet</p>
      <p class="empty-subtext">Customer feedback will appear here</p>
    </div>
    }

  </div>
  </div>
</ng-template>

<ng-template #productLibraryContent>
  <div class="product-library-container">

    <!-- Scrollable Content -->
    <div class="product-library-scroll-content">

      <!-- Search Box -->
      <div class="search-container">
        <div class="search-pill">
         
          <div class="search-box">
            <app-input [placeholder]="'Search by Network, Plan, Or Insurer.'" [formGroup]="searchForm"
              controlName="search" [disabled]="isProductLibraryLoading"
              (input)="onSearchChange($any($event.target).value)" (keydown.enter)="onSearchClick()" [isClearIcon]="true"
              (clearInput)="onClearSearch()"></app-input>
          </div>
          <button type="button" class="search-icon-btn" [disabled]="isSearchActionDisabled()"
            (click)="onSearchClick()" aria-label="Search product library">
            <mat-icon class="icon-search" svgIcon="icon-search"></mat-icon>
          </button>
        </div>
        @if(getSearchInputValue().length < MINIMUM_SEARCH_CHARACTERS){
          <p class="options-count validation-message">{{ searchValidationMessage }}</p>
        }
        <p *ngIf="productLibraryData?.productCount" class="options-count">{{ productLibraryData?.productCount | number
          }} options available.</p>
      </div>

      <!-- Product Library Section -->
       @if(productLibraryData?.productLibrary?.length === 0){
        <div class="section">
          <p  class="options-count no-product" >No matching product found.</p>
        </div>
       }
      @if (searchQuery && productLibraryData?.productLibrary?.length > 0) {
      <div class="section">
        @for (product of productLibraryData.productLibrary; track product.id) {
        <div class="product-card">
          <div class="top-row">
            <div class="plan-logo">
              <img [src]="getLogo(product.product?.insurer)" alt="Insurer Logo" class="orient-logo" />
            </div>
            <div class="product-info">
              <h4 class="product-name">{{ product.plan }}</h4>
              <p class="product-insurer">{{ product.product?.insurer }}</p>
            </div>
          </div>

          <div class="bottom-row">
            <div class="price-info">
              <p class="product-price">{{ product.network }}</p>
            </div>

            <div class="plan-add">
              <app-tooltip [text]="isPlanAdded(product.product?.productCode) ? 'Already Added' : 'Add Plan'"
                [position]="'above'">
                <button type="button" class="plan-add-btn" [disabled]="isPlanAdded(product.product?.productCode)"
                  [class.disabled]="isPlanAdded(product.product?.productCode)"
                  (click)="onAddProductLibraryPlan(product)">
                  <mat-icon class="icon-plus" svgIcon="plus"></mat-icon>
                </button>
              </app-tooltip>
            </div>
          </div>
        </div>
        }
      </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #aiAssistantContent>
  <div class="ai-assistant-container">

    <!-- Scrollable Chat Area -->
    <div class="ai-assistant-scroll-content" #chatScroll>
      @if (!hasChatStarted) {
      <div class="chat-messages">
        <div class="message-wrapper ai-message-wrapper">
          <div class="message-content ai-message">
            <p class="message-text ai-initial-text">Hello!! how can I help you today?</p>
          </div>
        </div>
      </div>
      } @else {
      <!-- Chat Messages -->
      <div class="chat-messages">
        @for (message of chatMessages; track message.id) {
        @if (message.type === 'ai') {
        <!-- AI Message -->
        <div class="message-wrapper ai-message-wrapper">
          <div class="message-content ai-message">
            <p class="message-text">{{ message.text }}</p>
          </div>
          <!-- CAN BE UNCOMMENTED IF WE WANT TO SHOW THE TIME OF AI MESSAGE IN CHAT -->
          <div class="message-meta">
            <div class="logo-insureliv">
              <mat-icon class="icon-logo" svgIcon="icon-insureliv"></mat-icon>
            </div>
            <span class="message-time">
              {{ formatChatDate(message.timestamp) }}
            </span>
          </div>
        </div>

        <!-- AI Plans (if any) -->
        @if (message.plans && message.plans.length > 0) {
        <div class="ai-plan-group">
          <div class="chat-plans-wrapper">
            <h4 class="chat-plans-title">Here you go:</h4>
            @for (  plan of message.plans; track plan.planId) {
            <div class="chat-plan-card">
              <div class="plan-top-row">
                <div class="plan-logo">
                  <img [src]="getLogo(plan.insurer)" alt="Insurer Logo" class="orient-logo" />
                </div>

                <div class="plan-info">
                  <h4 class="plan-name">{{ plan.planName }}</h4>
                  <p class="plan-insurer">{{ plan.insurer }}</p>
                </div>
              </div>

              <div class="plan-bottom-row">
                <div class="plan-price-info">
                  <p class="plan-price">{{plan.networkName}}</p>
                </div>

                <div class="plan-add">
                  <app-tooltip [text]="isPlanAdded(plan.planId) ? 'Already Added' : 'Add Plan'" [position]="'above'">
                    <button type="button" class="plan-add-btn" [disabled]="isPlanAdded(plan.planId)"
                      [class.disabled]="isPlanAdded(plan.planId)" (click)="onAddPlan(plan)">
                      <mat-icon class="icon-plus" svgIcon="plus"></mat-icon>
                    </button>
                  </app-tooltip>
                </div>
              </div>
            </div>
            }
          </div>
          <div class="message-meta">
            <div class="logo-insureliv">
              <mat-icon class="icon-logo" svgIcon="icon-insureliv"></mat-icon>
            </div>
            <span class="message-time">
              {{ formatChatDate(message.timestamp) }}
            </span>
          </div>
        </div>
        }
        } @else {
        <!-- User Message -->
        <div class="message-wrapper user-message-wrapper">
          <div class="message-content user-message">
            <p class="message-text">{{ message.text }}</p>
          </div>
        <!-- / -->
        </div>
        }

        <!-- Date Separator -->
        @if (
        $index < chatMessages.length - 1 && getDateGroup(formatChatDate(message.timestamp))
          !==getDateGroup(formatChatDate(chatMessages[$index + 1].timestamp)) ) { <div class="date-separator">
          <span class="separator-line"></span>
          <span class="separator-text">
            {{ getDateGroup(formatChatDate(chatMessages[$index + 1].timestamp)) }}
          </span>
          <span class="separator-line"></span>
      </div>
      }

      }
    </div>
    }
  </div>

  <!-- Fixed Chat Input at Bottom -->
  <div class="chat-input-container">
    <div class="chat-input-wrapper">
      <input type="text" class="chat-input" placeholder="Ask Anything" [(ngModel)]="chatInputText"
        (keyup.enter)="sendMessage()" />
      <button type="button" class="send-btn" (click)="sendMessage()">
        <mat-icon class="icon-send" svgIcon="icon-send"></mat-icon>
      </button>
    </div>
  </div>
  </div>
</ng-template>